class CreateMFA {
    constructor() {
        this.twoFaHandleForm();
    }

    twoFaHandleForm(){
        const form          = document.getElementById('frm-enableTwoStepForm-createMFAForm');
        const submitButton  = document.getElementById('create-two-step-submit');

        if(form){
            this.twoFaHandle();
            this.clipboard();
            const fv = new MfaInputValidator('frm-enableTwoStepForm-createMFAForm').enableMFAFormValidation();
            const submitForm = function () {
                fv.validate().then(function(status) {
                    if(status === 'Valid'){
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;
                        $('#frm-enableTwoStepForm-createMFAForm').submit();
                    }
                });
            }
            submitButton.addEventListener('click', function (e) {
                e.preventDefault();
                submitForm();
            });
            form.addEventListener('keyup', function(event) {
                if (event.code === 'Enter' || event.keyCode === 13)
                {
                    event.preventDefault();
                    submitForm();
                }
            });

            $.nette.ext('createTwoStepFormExt', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-enableTwoStepForm-createMFAForm'){
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                        if(payload['status'] === 'Valid'){
                            bootstrap.Modal.getInstance(document.getElementById('kt_modal_two_factor_authentication'), {}).hide();
                            new bootstrap.Modal(document.getElementById('kt_modal_back_up_codes'), {}).show();
                            var clipboard = new ClipboardJS('#copyCodes');
                            // Success and Error Handling
                            clipboard.on('success', function(e) {
                                toastr.success('Backup codes copied to clipboard.');
                                e.clearSelection();
                            });
                            clipboard.on('error', function(e) {
                                toastr.error('Failed to copy codes. Please copy them manually.');
                            });
                            ok.closeWebView();
                            webkit.messageHandlers.closeAction.postMessage('close');
                        }
                    }
                }
            });
        }
    }

    clipboard(){
        let target = document.getElementById('copy-mfa-secret-button');
        let clipboard = new ClipboardJS(target, {
            container: document.getElementById('kt_modal_two_factor_authentication'),
            target: target,
            text: function () {
                return $(target).attr('code');
            }
        });
        clipboard.on('success', function (e) {
            toastr.success('Multi-Factor authentication code has been saved into your clipboard.');
        });
    }
    twoFaHandle(){
        const form = document.querySelector('#frm-enableTwoStepForm-createMFAForm');
        if(form){
            new MfaInputEvents(form);
        }
    }
}
window.CreateMFA = CreateMFA;